import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  FormControl,
  Typography,
  Select,
  MenuItem,
  Button,
  DialogActions,
} from '@mui/material';

import { getPrinters } from '../../store/slices/orderSlice';

export default function ChangePrinter({ isOpen, handleClose, submitChanges }) {
  const dispatch = useDispatch();

  const [printer, setPrinter] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const previousSearchValues = useSelector(
    (state) => state.product.previousSearchValues
  );
  const warehouse = useSelector((state) => state.product.warehouseId);
  const availablePrinters = useSelector(
    (state) => state.order.availablePrinters
  );

  const { division } = previousSearchValues;

  const handlePrinterChange = (event) => {
    setPrinter(event.target.value);
    if (event.target.value) {
      setSubmitted(false);
    }
  };

  const handleSubmit = () => {
    if (!printer) {
      setSubmitted(true);
    } else {
      submitChanges(printer);
    }
  };

  useEffect(() => {
    const handleGetPrinters = () => {
      dispatch(getPrinters({ division, warehouse }));
    };
    handleGetPrinters();
  }, [division, warehouse, dispatch]);

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle component="div">
        <Typography variant="h3" sx={{ marginY: 1 }}>
          Change Printer
        </Typography>
      </DialogTitle>
      <FormControl sx={{ marginX: 5, marginBottom: 1.5 }}>
        {Array.isArray(availablePrinters) ? (
          <>
            <Typography variant="body1">Select a Printer</Typography>
            <Select
              id="printer-select"
              value={printer}
              onChange={handlePrinterChange}
              error={submitted && !printer}
              sx={{ width: '200px', height: '50px' }}
            >
              {availablePrinters.map((printer, index) => (
                <MenuItem key={`printer-${index}`} value={printer}>
                  {printer}
                </MenuItem>
              ))}
            </Select>
          </>
        ) : (
          <Typography variant="body2">{availablePrinters}</Typography>
        )}
      </FormControl>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained" color="success">
          Submit
        </Button>
        <Button onClick={handleClose} variant="outlined" color="error">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
